import React from "react";
import { Button } from "react-bootstrap";

const Logout = ({ dispatch }) => {
  const logOut = () => {
    localStorage.removeItem("token");
    window.location.reload();
  };

  return (

      <Button variant="outline-secondary" className="logout" onClick={logOut}>
        Logout
      </Button>

  );
};

export default Logout;
